/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Irreversible_Warning_AgentInputs */



/**
* | output |
* | --- |
* | "Once your organization allows it too, this agent will delete data, merge changes or restart devices — in oneAI and in connected systems — without asking. Thi..." |
*
* @param {Agent_Irreversible_Warning_AgentInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_irreversible_warning_agent = /** @type {((inputs?: Agent_Irreversible_Warning_AgentInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Irreversible_Warning_AgentInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Sobald Ihre Organisation es ebenfalls erlaubt, löscht dieser Agent Daten, führt Änderungen zusammen oder startet Geräte neu — in oneAI und in verbundenen Systemen —, ohne zu fragen. Das lässt sich nicht rückgängig machen.")
	return /** @type {LocalizedString} */ ("Once your organization allows it too, this agent will delete data, merge changes or restart devices — in oneAI and in connected systems — without asking. This cannot be undone.")
});